import { STATUS } from "@/constants/statuses";
import { applyTransaction } from "@datorama/akita";
import { Observable, catchError, map, tap } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import type { LoggerInterface } from "@interfaces/LoggerInterface";

import NudgesSettingsApiService from "../api_services/NudgesSettingsApiService/NudgesSettingsApiService";
import {
    NudgesSettingsResponseSchema,
    NudgesSettingsResponseType,
} from "../api_services/NudgesSettingsApiService/response/NudgesSettingsResponseSchema";
import NudgesSettingsStore from "../stores/NudgesSettingsStore";
import { nudgesApplicationLoggerToken } from "../tokens";

@singleton()
class NudgesSettingsService {
    constructor(
        private readonly nudgesSettingsApiService: NudgesSettingsApiService,
        private nudgesSettingsStore: NudgesSettingsStore,
        @inject(nudgesApplicationLoggerToken)
        private readonly logger: LoggerInterface
    ) {}

    isAllowed(): Observable<NudgesSettingsResponseType> {
        const status = this.nudgesSettingsStore.getStatus();
        this.nudgesSettingsStore.setStatus(
            status === STATUS.VIRGIN ? STATUS.INITIAL_LOADING : STATUS.LOADING
        );

        return this.nudgesSettingsApiService.isAllowed().pipe(
            map((value) => create(value, NudgesSettingsResponseSchema)),
            catchError((error: unknown) => {
                this.logger.debug(
                    "NudgesSettingsService.getCustomerActiveRewards is errored",
                    error
                );
                this.nudgesSettingsStore.setStatus(STATUS.ERROR);
                throw error;
            }),
            tap((value) => {
                this.logger.debug(
                    "NudgesSettingsService.getCustomerActiveRewards is ready"
                );
                //Store Update
                applyTransaction(() => {
                    this.nudgesSettingsStore.update((state) => ({
                        ...state,
                        isAllowed: value.isAllowed,
                    }));
                    this.nudgesSettingsStore.setStatus(STATUS.READY);
                });
            })
        );
    }
}

export default NudgesSettingsService;
